export default "__VITE_ASSET__DknAae0P__"